import { render, staticRenderFns } from "./DetailViewHeader.vue?vue&type=template&id=0f093fca"
import script from "./DetailViewHeader.js?vue&type=script&lang=js&external"
export * from "./DetailViewHeader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports